module.exports = __webpack_public_path__ + "img/056-guinea-bissau.b4efe7e1.svg";